import { Box, Button, Typography, useTheme } from '@mui/material'
import background from 'assets/images/noGoalContent.png'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import ImageContainer from 'components/atoms/container/ImageContainer'
import InCardStack from 'components/atoms/container/InCardStack'
import lock from 'assets/images/lock.svg'
import { useTranslation } from 'react-i18next'
import { MONARK_SUPPORT_EMAIL } from 'utils/constants'

const NoGoalContent = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Box
      width='100%'
      height={383}
      sx={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <BoxWithBackground
        backgroundColor={theme.palette.background.paper}
        maxWidth={320}
        padding={16}>
        <InCardStack spacing={8}>
          <ImageContainer src={lock} />
          <Typography textAlign='center' variant='body1Large'>
            {t('home.noGoalAccess')}
          </Typography>
          <Button href={`mailto:${MONARK_SUPPORT_EMAIL}`}>
            {t('home.requestAccess')}
          </Button>
        </InCardStack>
      </BoxWithBackground>
    </Box>
  )
}

export default NoGoalContent
